import { IUser } from '@connec10/media-interface/src/entity'
import { GetUserRequest, GetUserResponse } from '@connec10/media-interface/src/request'
import useSWR from 'swr'
import { axios } from '../../libs'
import { SWRCachePath } from '../swr-cache-path'

export const useGetUser = ({ userID }: GetUserRequest['param']) => {
  const { data, error } = useSWR<IUser>(SWRCachePath.USER + userID, () =>
    axios.get<GetUserResponse>(`/users/${userID}`).then<IUser>(res => res.data.user)
  )
  return {
    user: data,
    error,
    isLoading: !data && !error
  }
}
